import { keepPreviousData, queryOptions } from '@tanstack/react-query'

import type { AdminUserFilters } from '../model/types'

import {
  fetchAdminUser,
  fetchAdminUsers,
  fetchAdminUserSessions,
  fetchUserAudit,
} from './admin-users-api'
import { adminUserKeys } from './query-keys'

export const AUDIT_PAGE_SIZE = 50

/** goauth's own default is 50 and it clamps anything above 200. */
export const USERS_PAGE_SIZE = 50

export const adminUsersQuery = (filters: AdminUserFilters) =>
  queryOptions({
    queryKey: adminUserKeys.list(filters),
    queryFn: ({ signal }) => fetchAdminUsers(filters, signal),
    // Paging and typing in the search box must not blank the table underneath.
    placeholderData: keepPreviousData,
  })

export const adminUserQuery = (id: string) =>
  queryOptions({
    queryKey: adminUserKeys.detail(id),
    queryFn: ({ signal }) => fetchAdminUser(id, signal),
  })

export const adminUserSessionsQuery = (id: string) =>
  queryOptions({
    queryKey: adminUserKeys.sessions(id),
    queryFn: ({ signal }) => fetchAdminUserSessions(id, signal),
  })

export const userAuditQuery = (id: string, page: number) =>
  queryOptions({
    queryKey: adminUserKeys.audit(id, page),
    queryFn: ({ signal }) =>
      fetchUserAudit(id, { limit: AUDIT_PAGE_SIZE, offset: page * AUDIT_PAGE_SIZE }, signal),
    placeholderData: keepPreviousData,
  })
